<template>
  <div class="location-progress-table">
    <vue-good-table
      :columns="columns"
      :rows="rows"
      :sort-options="{ enabled: true }"
      :search-options="{ enabled: true, placeholder: 'Search...' }"
      :pagination-options="paginationOptions"
      style-class="vgt-table striped bordered"
    >
      <template slot="table-row" slot-scope="props">
        <span>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>
      <template v-slot:emptystate>
        <div class="custom-no-data text-center">
          No mentors found!
        </div>
      </template>
    </vue-good-table>
  </div>
</template>

<script>
import { VueGoodTable } from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css';

export default {
  name: 'LocationProgressTable',
  components: {
    VueGoodTable,
  },
  props: {
    mentorReviewList: {
      type: Array,
      required: true,
      default: () => []
    }
  },

  data() {
    return {
      columns: [
        {
          label: 'Mentor',
          field: 'mentorName',
          sortable: true,
          thClass: 'table-header',
          tdClass: 'table-cell'
        },
        {
          label: 'Reps Submitted',
          field: 'repsSubmitted',
          type: 'number',
          sortable: true,
          thClass: 'table-header text-left',
          tdClass: 'table-cell text-left'
        },
        {
          label: 'Reviewed',
          field: 'repsReviewed',
          type: 'number',
          sortable: true,
          thClass: 'table-header text-left',
          tdClass: 'table-cell text-left'
        },
        {
          label: 'Pending',
          field: 'repsPending',
          type: 'number',
          sortable: true,
          thClass: 'table-header text-left',
          tdClass: 'table-cell text-left'
        }
      ],
      paginationOptions: {
        enabled: true,
        perPage: 10,
        perPageDropdown: [],
        dropdownAllowAll: false,
        nextLabel: 'Next',
        prevLabel: 'Previous',
        rowsPerPageLabel: '',
        mode: 'records',
        infoFn: (params) => `Showing ${params.firstRecordOnPage} to ${params.lastRecordOnPage} of ${params.totalRecords} results`
      },
      thresholds: {
        red: '#EE4200',
        yellow: '#f4d454',
        green: '#009118'
      }
    };
  },

  computed: {
    rows() {
      return this.mentorReviewList.map(list => ({
        mentorName: list.mentorName,
        repsSubmitted: list.repsSubmitted,
        repsReviewed: list.repsReviewed,
        repsPending: list.repsPending
      }));
    }
  },

  methods: {
    getProgressColor(percent) {
      if (percent < 33) return this.thresholds.red;
      if (percent < 66) return this.thresholds.yellow;
      return this.thresholds.green;
    }
  }
};
</script>

<style scoped>
.location-progress-table {
  width: 100%;
  font-family: "proxima-nova",sans-serif;
  padding: 12px;
  padding-top: 0;
}

.table-header {
  color: #002F42;
  font-weight: normal;
  font-size: 13px;
  padding: 12px 16px;
  border-bottom: 2px solid #e5e7eb;
  background-color: #f9fafb;
}

.table-cell {
  padding: 10px 16px;
  font-size: 14px;
  color: #374151;
  border-bottom: 1px solid #e5e7eb;
}

.text-center {
  text-align: center;
}

.progress-badge {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 12px;
  color: #ffffff;
  font-weight: 600;
  font-size: 13px;
  min-width: 52px;
  text-align: center;
}

.progress-cell {
  display: flex;
  justify-content: center;
}

.location-progress-table >>> .vgt-table {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  overflow: hidden;
  border-collapse: separate;
  border-spacing: 0;
  background: #fff;
}

.location-progress-table >>> .vgt-table thead th {
  background: none;
  background-color: #FFF;
  color: #637383;
  font-weight: normal;
  font-size: 14px;
  padding: 9px 12px;
  border-right: 0 !important;
}

.location-progress-table >>> .vgt-table tbody tr:hover {
  background-color: #f0f9ff;
}

.location-progress-table >>> .vgt-table tbody td {
  font-size: 14px;
  padding: 8px 12px;
  color: #00233b;
  border-right: 0 !important;
}

.location-progress-table >>> .vgt-wrap__footer {
  border-top: 0;
  padding: 14px 0 0;
  font-size: 13px;
  color: #6b7280;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.location-progress-table >>> .vgt-wrap__footer .chevron {
  display: none;
}

.location-progress-table >>> .vgt-wrap__footer .footer__navigation__page-btn {
  color: #7c8896;
  border: 1px solid #d8e0e7;
  background: #FFF;
  border-radius: 9px;
  min-width: 70px;
  height: 30px;
  font-size: 13px;
  font-weight: 500;
  padding: 0 10px;
}

.location-progress-table >>> .vgt-wrap__footer .footer__navigation__page-btn:hover {
  color: #526071;
  background: #FFF;
}

.location-progress-table >>> .vgt-wrap__footer .footer__row-count {
  display: block !important;
  color: #5f7f9b;
  font-size: 14px;
  font-weight: 500;
  border: 0;
  margin-right: auto;
  text-align: left;
}

.location-progress-table >>> .vgt-wrap__footer .footer__row-count__label,
.location-progress-table >>> .vgt-wrap__footer .footer__row-count__select {
  display: none !important;
}

.location-progress-table >>> .vgt-wrap__footer .footer__navigation {
  margin-left: 0px;
  gap: 10px;
}


.location-progress-table >>> .vgt-global-search {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 14px;
  background: transparent !important;
  border: 0 !important;
  box-shadow: none !important;
  padding: 0 !important;
}

.location-progress-table >>> .vgt-global-search__input,
.location-progress-table >>> .vgt-input {
  width: 420px;
  max-width: 100%;
  height: 36px;
  border: 1px solid #d8e0e7;
  border-radius: 8px;
  padding: 8px 12px;
  font-size: 14px;
  color: #475569;
  background: #fff;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06);
}
.location-progress-table >>> .vgt-global-search__input {
    padding-left: 0px;
    border: 0;
    border-radius: 0;
    box-shadow: none;

}

.location-progress-table >>> .vgt-global-search__input::placeholder,
.location-progress-table >>> .vgt-input::placeholder {
  color: #7d8a99;
}

.location-progress-table >>> .vgt-global-search__actions {
  display: none;
}

/* Hide sort icons until a column is actively sorted. */
.location-progress-table >>> .vgt-table thead th.sortable .vgt-sortable:after {
  opacity: 0;
}

.location-progress-table >>> .vgt-table thead th.sorting-asc .vgt-sortable:after,
.location-progress-table >>> .vgt-table thead th.sorting-desc .vgt-sortable:after {
  opacity: 1;
}
</style>

<style>
.magnifying-glass, .vgt-wrap__footer .footer__row-count::after {
  display: none !important;
}
.vgt-inner-wrap {
  box-shadow: none !important;
}
.vgt-wrap__footer {
  border: 0 !important;
}
.vgt-table.bordered td, .vgt-table.bordered th {
  border: 0px;
  border-bottom: 1px solid #dcdfe6;
}
.vgt-table.striped tbody tr:nth-of-type(odd) {
  background: #FFF !important;
}
.vgt-wrap__footer .footer__navigation__page-btn span {
  font-size: 14px;
}
.vgt-wrap__footer .footer__navigation__page-btn {
  
}
.vgt-pull-right {
  width: 100%;
  padding: 0;
  margin: 0;
  text-align: right;
  display: flex;
}
.footer__navigation__page-info {
  margin: 0 !important;
  font-size: 14px;
  width: auto;
  color: #002f42 !important;
  flex-grow: 1;
  text-align: left;
  padding-top: 2px;
}
table.vgt-table td {
  color: #002F42 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/enterpriseadmin/mentee_review_status_list.vue